import { BodyProps } from "@ofqual/portal-activity-feed";
import { AdditionalEvidenceRequest } from "../../../domain/AdditionalEvidenceRequest";
import { ApplicationScopeStatus } from "../../../domain/Scope";
import { ScopeApplication } from "../../../domain/ScopeApplication";
import { fieldLabels } from "../../scopes/fieldLabels";

export type ExpansionActivityFeedProps = {
  application: ScopeApplication | null;
  evidenceRequests: AdditionalEvidenceRequest[] | null;
  disabled: boolean;
  isAdmin?: boolean;
};

export type AssignActivityBody = {
  AssignToUpn: string;
  AssignToDisplayName: string;
  Message: string;
};

export type DateActivityBody = {
  Date: string;
  Note: string;
  DateType: string;
};

export type ScopeDecisionChange = {
  ScopeTitle: string;
  FromStatus: ApplicationScopeStatus;
  ToStatus: ApplicationScopeStatus;
};

export type NoteActivityBody = {
  Note: string;
};

export enum ActionType {
  Note = 1,
  Document = 2,
  Date = 3,
  AdditionalEvidence = 4,
  SendMessage = 5,
}

export type AttachmentActivityBody = {
  Note: string;
  DocumentType?: string ;
  Documents: {
    BlobId: string;
    FileName: string;
    ContentType: string;
  }[];
};

export type CloseActivityBody = {
  Note: string;
  Letter: {
    BlobId: string;
    FileName: string;
    ContentType: string;
  };
};

export type AttachmentBodyProps = {
  bodyProps: BodyProps<AttachmentActivityBody>;
  getBlob: (blobId: string) => () => Promise<Blob>;
};

export type FieldChange = {
  Field: keyof typeof fieldLabels;
  OldValue: string | null;
  NewValue: string | null;
};

export type ChangeActivityBody = {
  Changes: FieldChange[];
  Title: string;
  Message: string;
};

export type StatementsOfAssurance = {
  ID: string,
  Name: string,
}

export type AdditionalEvidenceBody = {
  Title: string;
  DueDate: string;
  IsOtherEvidenceRequired: boolean;
  AllowAttachments: boolean;
  StatementsOfAssurance: StatementsOfAssurance[];
  IntroductionText: string;
  OtherEvidenceText: string;
  AdditionalEvidenceRequestId: string;
};

export type MessageActivityBody = {
  Message: string;
};

export type SubmittedEvidenceActivityBody = {
  Title: string;
  DueDate: string;
  AdditionalEvidenceRequestId: string;
};